<template>
  <el-container class="pages-common pre-tax-index">
    <leftNav />
    <el-main
      class="main-body"
      v-loading="loading"
      element-loading-text="导入中,请稍候"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(238, 238, 238, 0.9)"
    >
      <div class="page-header">
        <div class="title">实扣管理</div>
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
          style="display: inline-block"
        >
          <el-form-item label="姓名">
            <el-input
              v-model="formInline.name"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="工号">
            <el-input
              v-model="formInline.empNo"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input
              v-model="formInline.IDCord"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="扣款项目">
            <el-input
              v-model="formInline.projectName"
              placeholder="请输入"
              clearable
            ></el-input>
            <!-- <el-select clearable v-model="formInline.projectName" multiple :collapse-tags="true" >

<el-option label="项目名称1" value="项目名称1"></el-option>

<el-option label="项目名称2" value="项目名称2"></el-option>

</el-select> -->
          </el-form-item>
          <el-form-item label="扣款出处">
            <el-select clearable v-model="formInline.source">
              <el-option label="工资" value="工资"></el-option>
              <el-option label="佣金" value="佣金"></el-option>
              <el-option label="合作费" value="合作费"></el-option>
              <el-option label="均可" value="均可"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上期结余未扣金额是否为0">
            <el-select clearable v-model="formInline.balance">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应扣月份">
            <el-date-picker
              v-model="formInline.month"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              format="yyyy-MM"
              value-format="yyyy-MM"
              :unlink-panels="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="实扣月份">
            <el-date-picker
              v-model="formInline.actualMonth"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="actualdateChange"
              format="yyyy-MM"
              value-format="yyyy-MM"
              :unlink-panels="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="formInline.remark"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="部门">
            <el-select clearable v-model="formInline.bigDept">
              <el-option v-for="(item,index) in roles" :key="index" :label=item :value=item></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="onSubmit"
              >查询</el-button
            >
            <el-button type="warning" size="small" @click="onReset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
        <div>
          <el-upload
            class="upload-demo"
            :action="upfileUrl"
            :headers="myHeaders"
            :on-progress="uploadProgress"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :file-list="fileList"
            :show-file-list="false"
            accept=".xls,.xlsx"
          >
            <el-button size="small" type="primary">导入实扣</el-button>
          </el-upload>
          <el-button size="small" type="success" @click="downModel"
            >下载应扣余额</el-button
          >
          <el-button size="small" type="info" @click="exportExcels"
            >导出记录</el-button
          >
        </div>
        <!-- <el-button class="upload" size="small" type="success">上传类型表</el-button> -->
        <!-- <el-upload class="upload-demo" :action="actionUrl" :on-success='uploadSuccess' :on-error="uploadError" :file-list="fileList"

 :show-file-list="false" accept=".xls,.xlsx">

<el-button size="small" type="success">上传类型表</el-button>

</el-upload> -->
      </div>
      <div class="page-main">
        <el-table
          :data="tableData"
          border
          stripe
          size="small"
          :span-method="objectSpanMethod"
          max-height="500"
          :cell-style="cellStyle"
          :header-cell-style="{ borderColor: '#ccc' }"
        >
          <el-table-column label="导入时间" width="150" align="center">
            <template slot-scope="scope">
              {{ scope.row.createTime | FormatDate("YYYY/mm/dd HH:MM:SS") }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createEmpName"
            label="导入人员"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="empName"
            label="姓名"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="empNo" label="工号" width="100" align="center">
          </el-table-column>
          <el-table-column prop="dept" label="组别" width="100" align="center">
          </el-table-column>
          <el-table-column prop="bigDept" label="部门" width="100" align="center">
          </el-table-column>
          <el-table-column
            prop="idCard"
            label="身份证号码"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="chargeMonth"
            label="应扣月份"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="chargeItem"
            label="扣款项目"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="chargeFrom"
            label="扣款出处"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            width="100"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="shouldChargeTotal"
            label="应扣金额合计"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="noChargeTotal"
            label="上期结余未扣金额"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column label="实扣月份" width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.details.realChargeMonth }}
            </template>
          </el-table-column>
          <el-table-column label="本期工资实扣" width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.details.realChargeWage }}
            </template>
          </el-table-column>
          <el-table-column label="本期合作费实扣" width="110" align="center">
            <template slot-scope="scope">
              {{ scope.row.details.realChargeCoop }}
            </template>
          </el-table-column>
          <el-table-column label="本期绩效实扣" width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.details.realChargePerformance }}
            </template>
          </el-table-column>
          <el-table-column label="本期佣金实扣" width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.details.realChargeCommission }}
            </template>
          </el-table-column>
          <el-table-column label="本期花红实扣" width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.details.realChargeBonus }}
            </template>
          </el-table-column>
          <el-table-column label="本期合计实扣" width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.details.realChargeTotal }}
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import leftNav from "../components/nav.vue";
import { getRealCharge } from "../api/index";
import rootUrl from "../utils/api";
export default {
  components: {
    leftNav,
  },
  data() {
    return {
      formInline: {},
      currentPage: 1,
      total: 40,
      pageSize: 20,
      tableData: [],
      fileList: [],
      upfileUrl: rootUrl + "/real-charge/upload",
      spanArr: [],
      position: 0,
      realMonthStart: "",
      shouldMonthStart: "",
      realMonthEnd: "",
      shouldMonthEnd: "",
      myHeaders: {
        token: this.$store.state.loginToken,
      },
      roles:this.$store.state.loginInfo.depts,
      loading: false,
    };
  },
  mounted() {
    document.title = "实扣管理";
    this.queryList();
  },
  methods: {
    queryList() {
      let data = {
        remark: this.formInline.remark ? this.formInline.remark : "", //备注
        chargeFrom: this.formInline.source ? this.formInline.source : "", //扣款出处
        chargeItem: this.formInline.projectName
          ? this.formInline.projectName
          : "", //扣款项目
        current: this.currentPage ? this.currentPage : "", //当前页
        size: this.pageSize ? this.pageSize : "", //每页数量
        empName: this.formInline.name ? this.formInline.name : "", //姓名
        empNo: this.formInline.empNo ? this.formInline.empNo : "", //工号
        idCard: this.formInline.IDCord ? this.formInline.IDCord : "", //身份证号码
        realMonthStart: this.realMonthStart,
        realMonthEnd: this.realMonthEnd,
        shouldMonthStart: this.shouldMonthStart,
        shouldMonthEnd: this.shouldMonthEnd,
        flag:
          this.formInline.balance != undefined ? this.formInline.balance : "",
        bigDept:this.formInline.bigDept ? this.formInline.bigDept : "",
      };
      console.log("274" + data.flag);
      getRealCharge(data)
        .then((res) => {
          if (res.code == 200) {
            var tempArr = JSON.parse(JSON.stringify(res.data.rows));
            var newArr = [];
            tempArr.map((item, index) => {
              if (item.details.length == 0) {
                newArr.push({
                  index: index,
                  createTime: item.createTime,
                  createEmpName: item.createEmpName,
                  chargeFrom: item.chargeFrom,
                  chargeItem: item.chargeItem,
                  chargeMonth: item.chargeMonth,
                  dept: item.dept,
                  bigDept: item.bigDept,
                  details: "",
                  empName: item.empName,
                  empNo: item.empNo,
                  idCard: item.idCard,
                  noChargeTotal: item.noChargeTotal,
                  realChargeTotal: item.realChargeTotal,
                  shouldChargeTotal: item.shouldChargeTotal,
                  remark: item.remark,
                });
              } else {
                item.details.map((items) => {
                  var tempItem = {
                    index: index,
                    createTime: item.createTime,
                    createEmpName: item.createEmpName,
                    chargeFrom: item.chargeFrom,
                    chargeItem: item.chargeItem,
                    chargeMonth: item.chargeMonth,
                    dept: item.dept,
                    bigDept: item.bigDept,
                    details: items,
                    empName: item.empName,
                    empNo: item.empNo,
                    idCard: item.idCard,
                    noChargeTotal: item.noChargeTotal,
                    realChargeTotal: item.realChargeTotal,
                    shouldChargeTotal: item.shouldChargeTotal,
                    remark: item.remark,
                  };
                  newArr.push(tempItem);
                });
              }
            });
            this.tableData = newArr;
            this.rowspan();
            console.log(this.tableData);
            this.total = res.data.total;
          } else {
            this.showMessage("error", res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSubmit() {
      // console.log("onSubmit");
      // console.log(this.formInline);
      this.currentPage = 1;
      this.queryList();
    },
    onReset() {
      // console.log("onReset");
      this.formInline = {};
      this.currentPage = 1;
      this.realMonthStart = "";
      this.shouldMonthStart = "";
      this.realMonthEnd = "";
      this.shouldMonthEnd = "";
      this.queryList();
    },
    uploadProgress(response, file, fileList) {
      this.loading = true;
    },
    uploadSuccess(response, file, fileList) {
      // console.log(response);
      // console.log(file);
      if (response.code == 200) {
        this.showMessage("success", response.message);
      } else {
        this.showMessage("error", response.message);
      }
      this.loading = false;
      this.currentPage = 1;
      this.queryList();
    },
    uploadError(err, file, fileList) {
      console.log(err);
      console.log(file);
      this.loading = false;
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.queryList();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryList();
      console.log(`当前页: ${val}`);
    },
    showMessage(type, msg) {
      this.$message({
        message: msg,
        type: type,
        duration: 5000,
        center: true,
      });
    },
    //获得数据相同的行数
    rowspan() {
      //每次调用清空数据
      this.spanArr = [];
      this.position = 0;
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (this.tableData[index].index === this.tableData[index - 1].index) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = index;
          }
        }
      });
    },

    //合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //表格合并行
      if (columnIndex < 11) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    //应扣月份变化
    dateChange() {
      if (this.formInline.month == null) {
        this.shouldMonthStart = "";
        this.shouldMonthEnd = "";
      } else {
        this.shouldMonthStart = this.formInline.month[0];
        this.shouldMonthEnd = this.formInline.month[1];
      }
    },
    //实扣月份变化
    actualdateChange() {
      if (this.formInline.actualMonth == null) {
        this.realMonthStart = "";
        this.realMonthEnd = "";
      } else {
        this.realMonthStart = this.formInline.actualMonth[0];
        this.realMonthEnd = this.formInline.actualMonth[1];
      }
    },

    //设置单元格背景
    cellStyle({ row, column, rowIndex, columnIndex }) {
      return "border-color:#ccc!important;";
    },
    //下载
    downModel() {
      this.xhr = new XMLHttpRequest();
      this.xhr.open("GET", rootUrl + "/charge-summary/export", true);
      this.xhr.responseType = "blob";
      var vmThis = this;
      this.xhr.onload = () => {
        if (this.xhr.status === 200) {
          if (
            this.xhr.response &&
            this.xhr.response.size &&
            this.xhr.response.size > 0
          ) {
            let file = this.xhr.response;
            let fileName = "实扣数据.xlsx";
            if ("msSaveOrOpenBlob" in navigator) {
              window.navigator.msSaveOrOpenBlob(file, fileName);
            } else {
              let fileUrl = window.URL.createObjectURL(file);
              let a = document.createElement("a");
              a.download = fileName;
              a.href = fileUrl;
              document.getElementsByTagName("body")[0].appendChild(a);
              a.click();
              a.parentNode.removeChild(a);
              window.URL.revokeObjectURL(fileUrl);
            }
          }
        } else {
          //
        }
      };
      this.xhr.setRequestHeader("token", this.$store.state.loginToken);
      this.xhr.send();
    },


    exportExcels() {
      let data = {
        remark: this.formInline.remark ? this.formInline.remark : "", //备注
        chargeFrom: this.formInline.source ? this.formInline.source : "", //扣款出处
        chargeItem: this.formInline.projectName
          ? this.formInline.projectName
          : "", //扣款项目
        current: this.currentPage ? this.currentPage : "", //当前页
        size: this.pageSize ? this.pageSize : "", //每页数量
        empName: this.formInline.name ? this.formInline.name : "", //姓名
        empNo: this.formInline.empNo ? this.formInline.empNo : "", //工号
        idCard: this.formInline.IDCord ? this.formInline.IDCord : "", //身份证号码
        realMonthStart: this.realMonthStart,
        realMonthEnd: this.realMonthEnd,
        shouldMonthStart: this.shouldMonthStart,
        shouldMonthEnd: this.shouldMonthEnd,
        flag:
          this.formInline.balance != undefined ? this.formInline.balance : "",
        bigDept:this.formInline.bigDept ? this.formInline.bigDept : "",
      };
      this.xhr = new XMLHttpRequest();
      this.xhr.open("GET", rootUrl + `/real-charge/export?chargeFrom=${data.chargeFrom}&chargeItem=${data.chargeItem}&current=${data.current}&empName=${data.empName}&empNo=${data.empNo}&flag=${data.flag}&idCard=${data.idCard}&realMonthEnd=${data.realMonthEnd}&realMonthStart=${data.realMonthStart}&remark=${data.remark}&shouldMonthEnd=${data.shouldMonthEnd}&shouldMonthStart=${data.shouldMonthStart}&size=${data.size}&bigDept=${data.bigDept}`, true);
      this.xhr.responseType = "blob";
      var vmThis = this;
      this.xhr.onload = () => {
        if (this.xhr.status === 200) {
          if (
            this.xhr.response &&
            this.xhr.response.size &&
            this.xhr.response.size > 0
          ) {
            let file = this.xhr.response;
            let fileName = "实扣管理导出.xlsx";
            if ("msSaveOrOpenBlob" in navigator) {
              window.navigator.msSaveOrOpenBlob(file, fileName);
            } else {
              let fileUrl = window.URL.createObjectURL(file);
              let a = document.createElement("a");
              a.download = fileName;
              a.href = fileUrl;
              document.getElementsByTagName("body")[0].appendChild(a);
              a.click();
              a.parentNode.removeChild(a);
              window.URL.revokeObjectURL(fileUrl);
            }
          }
        } else {
          //
        }
      };
      this.xhr.setRequestHeader("token", this.$store.state.loginToken);
      this.xhr.send();
    },
  },
};
</script>

<style>
.el-date-editor .el-range-separator {
  padding: 0 !important;
}
</style>
